var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [_vm.$style.button, _vm.buttonTypeClass],
      attrs: { type: _vm.type, disabled: _vm.disabled },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.handleClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "span",
        {
          class:
            ((_obj = {}),
            (_obj[_vm.$style.fadeTransition] = true),
            (_obj[_vm.$style.fadeTo] = _vm.isLoading),
            _obj),
        },
        [
          _vm._t("default", function () {
            return [_vm._v("default text")]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            enterClass: _vm.$style.fadeTo,
            enterActiveClass: _vm.$style.fadeTransition,
            leaveActiveClass: _vm.$style.fadeTransition,
            leaveToClass: _vm.$style.fadeTo,
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { class: _vm.$style.loadingIconContainer },
                [_c("LoadingIcon")],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }